

































































import { Vue, Component } from 'vue-property-decorator'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { APIRole } from '../../models/api/role.model'
import { APIPermission } from '../../models/api/permission.model'

@Component({
    components: {
        ConfirmDialog
    }
})
export default class UserPermissionsForm extends Vue {
    loading = true
    cardTitle = ''

    buttonLoading = false

    formData: { permissions: APIPermission[] } = {
        permissions: []
    }

    formValid = false
    formRules = {}
    formModel: { roles: APIRole[]; userRoles: APIRole[]; userPermissions: APIPermission[] } = {
        roles: [],
        userRoles: [],
        userPermissions: []
    }

    async mounted () {
        this.cardTitle = 'Edit User Permissions'
        await this.getUserById()
        if (this.formModel.userRoles.length > 0) await this.getRolesById()
        await this.getPermissions()
    }

    getUserById () {
        this.loading = true
        return new Promise(resolve => {
            if (!this.$route.params.id) {
                this.$store.commit('reportError', { code: 1000, message: 'Error, not id sended in route params :(' })
                this.loading = false
                return
            }

            this.$store.dispatch('getUserById', this.$route.params.id)
                .then(resp => {
                    if (resp?.status === 200) {
                        this.formModel.userRoles = JSON.parse(JSON.stringify(this.$store.state.UsersStore.userForm.roles))
                        this.formModel.userPermissions = JSON.parse(JSON.stringify(this.$store.state.UsersStore.userForm.permissions))
                        this.loading = false
                        resolve()
                    }
                })
        })
    }

    getRolesById () {
        return new Promise(resolve => {
            this.formModel.userRoles.forEach(role => {
                this.$store.dispatch('getRolesById', role.roleId)
                    .then(resp => {
                        if (resp?.status === 200) {
                            this.formModel.roles.push(this.$store.state.RolesStore.roleForm)
                            resolve()
                        }
                    })
            })
        })
    }

    getPermissions () {
        return new Promise(resolve => {
            this.$store.dispatch('getPermissions')
                .then(resp => {
                    if (resp?.status === 200) {
                        this.formData.permissions = JSON.parse(JSON.stringify(this.$store.state.PermissionsStore.permissions))
                        this.formData.permissions.forEach(p => {
                            if (this.formModel.userPermissions.find(permission => permission.permissionId === p.permissionId)) {
                                p.active = true
                            }

                            this.formModel.roles.forEach(r => {
                                if (r.permissions && r.permissions.find(permission => permission.permissionId === p.permissionId)) {
                                    p.locked = true
                                }
                            })
                        })
                        resolve()
                    }
                })
        })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        const addedPermissions: APIPermission[] = []
        const removedPermissions: APIPermission[] = []

        let changed = false

        this.formData.permissions.forEach(permission => {
            if (permission.active && this.formModel.userPermissions && !this.formModel.userPermissions.find(p => p.permissionId === permission.permissionId)) {
                addedPermissions.push(permission)
            }
            if (!permission.active && this.formModel.userPermissions && this.formModel.userPermissions.find(p => p.permissionId === permission.permissionId)) {
                removedPermissions.push(permission)
            }
        })

        this.buttonLoading = true

        if (addedPermissions.length > 0) {
            await this.$store.dispatch(
                'addPermimissionToUser',
                {
                    userId: this.$route.params.id,
                    permissions: addedPermissions
                })
                .then(async (resp) => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        changed = true
                    }
                })
        }
        if (removedPermissions.length > 0) {
            await this.$store.dispatch(
                'removePermissionToUser',
                {
                    userId: this.$route.params.id,
                    permissions: removedPermissions
                })
                .then(async (resp) => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        changed = true
                    }
                })
        }

        if (changed) {
            this.loading = true
            await this.getUserById()
            await this.getRolesById()
            await this.getPermissions()
            this.buttonLoading = false
        } else {
            this.buttonLoading = false
        }
    }
}
